export default "__VITE_ASSET__$XQrEEcx__"